import React from "react";
import {Route, Switch} from "react-router-dom";
import KinerjaKeuangan from "pages/UserPinca/index";

const UserPinca = ({match}) => (
  <Switch>
    <Route path={`${match.url}/kinerja-keuangan`} component={KinerjaKeuangan}/>
  </Switch>
);

export default UserPinca;
